import { collection, query, orderBy, getDocs } from "firebase/firestore";
import { firestore as db } from "@/utils/firebase";
import { Message } from "./types";

/**
 * Get all messages in a session, ordered by timestamp
 */
export const getSessionMessages = async (
  userId: string,
  sessionId: string
): Promise<Message[]> => {
  const messagesCollection = collection(
    db,
    "users",
    userId,
    "sessions",
    sessionId,
    "messages"
  );

  const q = query(messagesCollection, orderBy("timestamp", "asc"));
  const querySnapshot = await getDocs(q);

  return querySnapshot.docs.map((doc) => doc.data()) as Message[];
};
